import React, { Component } from "react";
import MainLinkList from "./main-link-list";
import SecondaryLinkList from "./secondary-link-list";
import SocialMedia from "./social-media";
import InternalLink from "./internal-link";
import MainLogo from "./main-logo";
 
class Footer extends Component {
  constructor() {
    super();
  }

  render() {
    const { footerProps } = this.props;
    if (!footerProps || process.env.NEXT_PUBLIC_WEB_VIEW === 'true') {
      return null;
    }
    const footerMock = footerProps;
    const mediaLinks = footerMock["media-links"];
    return (
      <footer className="footer">
        <div className="block-1">
          <MainLinkList data={footerMock["main-link-list"]} />
        </div>
        <div className="block-2">
          <div className="content container">
            <div className="media-container">
              <SocialMedia data={mediaLinks["social-media"]} />
              <span className="separator-container">
                <span />
              </span>
              <InternalLink {...mediaLinks["internal-link"]} />
            </div>
            <span className="separator-horizontal" />
            <SecondaryLinkList data={footerMock["secondary-link-list"]} />
            <MainLogo {...mediaLinks["main-logo"]} />
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
